/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    buttonLoader: "calcite-button--loader",
    content: "content",
    contentSlotted: "content--slotted",
    icon: "icon",
    iconStart: "icon--start",
    iconEnd: "icon--end",
    loadingIn: "loading-in",
    loadingOut: "loading-out",
    iconStartEmpty: "icon-start-empty",
    iconEndEmpty: "icon-end-empty",
    buttonPadding: "button-padding",
    buttonPaddingShrunk: "button-padding--shrunk",
};
//# sourceMappingURL=resources.js.map
